import React, { useEffect, useState } from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import "./Stats.scss";
import Title from "../../components/Title/Title";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { romanize, useAppDispatch } from "../../hooks";
import { listRanking, listStats } from "../../store/actions/rankings";
import {
  getVisitHistory,
  getWholesaleRanking,
} from "../../store/reducers/rankings";
import { ReactComponent as ShowMoreIcon } from "./img/show-more.svg";
import ButtonTab from "../../components/ButtonTab/ButtonTab";
const Stats = () => {
  const visitHistory = useSelector(getVisitHistory);
  const rankingList = useSelector(getWholesaleRanking);
  const dispatch = useAppDispatch();
  const [showMore, setShowMore] = useState(false);
  const showButton = visitHistory.length > 10 && !showMore;
  const filteredVisitHistory = showMore
    ? visitHistory
    : visitHistory.slice(0, 10);
  const rankingArray = Object.entries(
    rankingList?.rankings?.list_wholesaleRanking?.ranking?.ranking || {}
  );

  useEffect(() => {
    dispatch(listStats());
    dispatch(listRanking());
  }, []);

  const [transactionListType, setTransactionListType] = useState("stats");

  const handlePageChange = (event: any) => {
    //dispatch(balanceHistory((event.selected * 100) % visitHistoryCount))
  };

  useEffect(() => {}, [transactionListType]);

  // let ranking = {
  //   "3fa526b0-84b7-11ef-bf04-06a66d235356": 12,
  //   "3f86c4c5-84b7-11ef-bf04-06a66d235356": 11,
  //   "3f6fdf96-84b7-11ef-bf04-06a66d235356": 11,
  //   "3f617500-84b7-11ef-bf04-06a66d235356": 10,
  // };

  // let rankingArray = Object.entries(ranking);

  // setTimeout(() => {
  //   rankingArray = Object.entries(
  //     rankingList?.rankings?.list_wholesaleRanking?.ranking?.ranking
  //   );
  // }, 1500);

  const wholesaler =
    rankingList.rankings.list_wholesaleRanking.wholesalerBranch;

  return (
    <PageLayout withBottom>
      <section className="page Stats">
        <Title>Raportowanie i rankingi </Title>
      </section>
      <div className="stats-bottom-section">
        <div>
          <div className="button-tab-wrapper">
            <ButtonTab
              active={transactionListType === "stats"}
              onClick={() => setTransactionListType("stats")}
            >
              Moje statystyki
            </ButtonTab>
            <ButtonTab
              active={transactionListType === "ranking"}
              onClick={() => setTransactionListType("ranking")}
            >
              Ranking
            </ButtonTab>
          </div>
        </div>
        <div className="history-section">
          {transactionListType === "stats" && (
            <div className="stats-wrapper">
              <div className="table-wrapper">
                <h3>Raport moich wizyt</h3>
                <div className="table-header">
                  <span> Data </span>
                  <span> Numer punktu sprzedażowego </span>
                </div>
                <table>
                  <tbody>
                    {filteredVisitHistory.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                          <td className="date">
                            {moment(item?.created?.date).format("DD.MM.YYYY")}
                          </td>
                          <td className="name">{item?.sap?.ident}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {showButton && (
                  <button
                    onClick={() => setShowMore(true)}
                    className="show-more-cta"
                  >
                    Pokaż więcej <ShowMoreIcon />
                  </button>
                )}
              </div>
              {/*visitHistoryCount <= 100 ? null :
              <div className="pagination">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={handlePageChange}
                  pageRangeDisplayed={5}
                  pageCount={visitHistoryCount / 100}
                  previousLabel="<"
                />
              </div>
              */}
            </div>
          )}

          {transactionListType === "ranking" && (
            <div className="stats-wrapper">
              <div className="table-wrapper">
                <h3>Ranking hurtowni</h3>
                <p>
                  Łączna liczba zarejestrowanych wizyt przez wszystkich
                  użytkowników w danej hurtowni w ramach trwającego zadania
                  (wartości mogą ulec zmianie po zakończeniu zadania i
                  weryfikacji).
                </p>
                <div className="table-header">
                  <span> Hurtownia </span>
                  <span> Wynik </span>
                </div>
                <table>
                  <tbody>
                    {rankingArray?.map(([uuid, score]: any, index: any) => {
                      if (index == 10) {
                        return (
                          <>
                            <tr key={uuid + 2}>
                              <td className="date">...</td>
                              <td className="name"></td>
                            </tr>
                            <tr key={uuid} className={"blue"}>
                              <td className="date">{wholesaler.ident}</td>
                              <td className="name">{score}</td>
                            </tr>
                          </>
                        );
                      } else {
                        return (
                          <tr
                            key={uuid}
                            className={uuid === wholesaler.uuid ? "blue" : ""}
                          >
                            <td className="date">
                              {index + 1}.{" "}
                              {uuid === wholesaler.uuid
                                ? wholesaler.ident
                                : "Inna hurtownia"}
                            </td>
                            <td className="name">{score}</td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
                {showButton && (
                  <button
                    onClick={() => setShowMore(true)}
                    className="show-more-cta"
                  >
                    Pokaż więcej <ShowMoreIcon />
                  </button>
                )}
              </div>
              {/*visitHistoryCount <= 100 ? null :
              <div className="pagination">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={handlePageChange}
                  pageRangeDisplayed={5}
                  pageCount={visitHistoryCount / 100}
                  previousLabel="<"
                />
              </div>
              */}
            </div>
          )}
        </div>
      </div>
    </PageLayout>
  );
};

export default Stats;
